import cn from 'classnames';
import { ReactElement, ReactNode } from 'react';

import styles from './Heading.module.scss';

export interface HeadingProps {
  semanticLevel: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span';
  styleLevel: 'display' | '1' | '2' | '3' | '4' | '5' | '6' | '7';
  className?: string;
  id?: string;
  children: ReactNode;
}

const Heading = ({
  semanticLevel: SemanticTag = 'h1',
  styleLevel,
  children,
  className,
  id,
}: HeadingProps): ReactElement => {
  const styleClass = cn(className, {
    [styles[`heading${styleLevel}`]]: !!styleLevel,
  });

  return (
    <SemanticTag
      className={styleClass}
      id={id ?? undefined}
      data-testid="Heading"
    >
      {children}
    </SemanticTag>
  );
};

export default Heading;
